import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface GAEvent {
    event: "GAEvent";
    GAEventCategory: "nawigacja";
    GAEventAction: string;
    GAEventLabel: string;
    GAEventNoInteraction: true;
}

export const gtmEventNavigationClick = (navLevel: string, text: string) => {
    const gtmData: GAEvent = {
        event: "GAEvent",
        GAEventCategory: "nawigacja",
        GAEventAction: navLevel,
        GAEventLabel: text,
        GAEventNoInteraction: true
    };
    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface GAEvent {
    event: "GAEvent";
    GAEventCategory: "nawigacja";
    GAEventAction: string;
    GAEventLabel: string;
    GAEventNoInteraction: true;
}

export const gtmEventNavigationClick = (navLevel: string, text: string) => {
    const gtmData: GAEvent = {
        event: "GAEvent",
        GAEventCategory: "nawigacja",
        GAEventAction: navLevel,
        GAEventLabel: text,
        GAEventNoInteraction: true
    };
    hitGoogleTagManager(gtmData);
};
